module.exports = __webpack_public_path__ + "img/big-logo.d9972504.png";